import { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { LAST_MEALS_PAGE_KEY } from '@/features/meals/constants';
import { FEATURE_FLAGS } from '@/featureFlags';

export function MealsPage() {
  const { householdId } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    const lastPage = localStorage.getItem(LAST_MEALS_PAGE_KEY);
    if (FEATURE_FLAGS.mealTracking && lastPage === 'log') {
      navigate(`/h/${householdId}/meals/log`, { replace: true });
    } else {
      navigate(`/h/${householdId}/meals/plan`, { replace: true });
    }
  }, [householdId, navigate]);

  return null;
}
